import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import Invoices from '../../../../components/Query/Invoices';
import { url, attachmentUrl } from '../../../../config/config';
import { MutationFunc } from 'react-apollo';
import { Button, Table, Divider, Modal, notification, Menu, Dropdown, Upload } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import * as moment from 'moment';
import axios from 'axios';
import InvoiceDetail from 'src/scenes/Invoice/InvoiceDetail';

interface IOrderInformationProps extends RouteComponentProps {
  domain: string;
  orderId: string;
  createInvoice?: MutationFunc;
  updateInvoice?: MutationFunc;
  letterData?: any;
  refetchOrder?: () => void;
}

interface IOrderInformationState {
  editInvoice: GQL.IInvoice | null;
  publishingToQuickbooks: boolean | null;
}

class OrderInvoices extends React.Component<IOrderInformationProps, IOrderInformationState> {
  
  constructor(props: IOrderInformationProps) {
    super(props);

    this.state = {
      editInvoice: null,
      publishingToQuickbooks: null,
    };

    this.generateInvoice = this.generateInvoice.bind(this);
    this.hideEditModal = this.hideEditModal.bind(this);
  }

  private handleGenerateInvoice = async (type: any, invoiceType: string, refetch: () => void) => {
    if (type && type.key && type.key !== 'upload') {
      const sendToCustomer = type && type.key && type.key === 'generateAndSend';
      await this.generateInvoice(invoiceType, sendToCustomer);
      refetch();
    }
  }

  private hasLetterDataFor(type: string) {
    const { letterData } = this.props;
    if (letterData && letterData.letterData) {
      return letterData.letterData.find((ld: GQL.ILetterData) => ld[type] === true) !== undefined;
    }
    return false;
  }

  public render() {

    const generateDropDownMenu = (invoiceType: string, refetch: () => void) => {
      const letterDataFor = (invoiceType === 'proforma' ? 'sendProformaToCustomer' : 'sendInvoiceToCustomer');

      return (
        <Menu onClick={(e: any) => this.handleGenerateInvoice(e, invoiceType, refetch)}>
          <Menu.Item key="upload" className="menu-item-upload-file">
            <Upload
              accept={'application/pdf'}
              action={`${attachmentUrl}/uploadInvoice?orderId=${this.props.orderId}&type=${invoiceType}`}
              listType="text"
              showUploadList={false}
              onChange={({ file }: any) => {
                if (file && file.response && file.response.id) {
                  refetch();
                  // done
                  notification['success']({
                    message: 'Info',
                    description: `${invoiceType === 'invoice' ? `Invoice` : `Proforma`} has been uploaded.`
                  });
                }
              }}
            >
              <div>Upload</div>
            </Upload>
          </Menu.Item>
          <Menu.Item key="generate">
            Generate
          </Menu.Item>
          <Menu.Item key="generateAndSend" disabled={!this.hasLetterDataFor(letterDataFor)}>
            Generate and send to customer
          </Menu.Item>
        </Menu>
      );
    };

    return (
      <div>
        <Invoices orderId={this.props.orderId}>
          {({ invoices, publishToFreshbooks, sendInvoice, deleteInvoice }: any) => {

            if (invoices.loading || !Array.isArray(invoices.invoices)) {
              return <div />;
            }

            // seznam faktur, a zálohových faktur
            const listInvoices = invoices.invoices.filter((invoice: GQL.IInvoice) => invoice.type === 'invoice');
            const listProformas = invoices.invoices.filter((invoice: GQL.IInvoice) => invoice.type === 'proforma');

            return (
              <div>

                {this.state.editInvoice !== null &&
                  <InvoiceDetail 
                    invoice={this.state.editInvoice}
                    updateInvoice={this.props.updateInvoice}
                    onSubmit={() => {
                      invoices.refetch();
                      this.hideEditModal();
                    }}
                    onCancel={this.hideEditModal}
                  />}

                <div>
                  <Dropdown
                    overlay={generateDropDownMenu('proforma', invoices.refetch)}
                    disabled={listProformas.length > 0}
                  >
                    <Button
                      type={'primary'}
                      disabled={listProformas.length > 0}
                    >
                      Generate proforma <DownOutlined />
                    </Button>
                  </Dropdown>
                  <Divider type={'vertical'} style={{ height: 32 }}/>
                  <Dropdown
                    overlay={generateDropDownMenu('invoice', invoices.refetch)}
                    disabled={listInvoices.length > 0}
                  >
                    <Button
                      type={'primary'}
                      disabled={listInvoices.length > 0}
                    >
                      Generate invoice <DownOutlined />
                    </Button>
                  </Dropdown>
                </div>

                <Table
                  rowKey={(record: GQL.IOrder) => record.id}
                  dataSource={invoices.invoices}
                  defaultExpandAllRows={true}
                  style={{ marginTop: '20px' }}
                >
                  <Table.Column
                    title="Created at"
                    dataIndex="createdAt"
                    key="createdAt"
                    render={(u, row: GQL.IInvoice) => {
                      return (
                        <span>
                          {moment(new Date(row.createdAt))
                            .local()
                            .format('DD/MM/YY HH:mm')}
                        </span>
                      );
                    }}
                  />
                  <Table.Column
                    title="Type"
                    dataIndex="type"
                    key="type"
                    render={(u, row: GQL.IInvoice) => {
                      const type = row.type.toLowerCase() === 'proforma' ? 'Proforma' : 'Invoice';

                      return `${type}${row.sourceFile && row.sourceFile !== '' ? ' (external PDF)' : ''}`;
                    }}
                  />
                  <Table.Column
                    title="Number"
                    dataIndex="invoiceNumber"
                    key="invoiceNumber"
                    render={(u, invoice: GQL.IInvoice) => {
                      if (invoice.sourceFile && invoice.sourceFile !== '') {
                        return '-';
                      }
                      return invoice.invoiceNumber;
                    }}
                  />
                  <Table.Column
                    title="Actions"
                    dataIndex="actions"
                    key="actions"
                    render={(u: any, row: any) => this.renderActions(row, publishToFreshbooks, sendInvoice, deleteInvoice, invoices.refetch)}
                  />
                </Table>
              </div>
            );
          }}
        </Invoices>
      </div>
    );
  }

  private renderActions(
    row: GQL.IInvoice, 
    publishToFreshbooks: Function, 
    sendInvoice: Function,
    deleteInvoice: Function,
    refetch: Function
  ) {
    return (
      <div>
        <Button onClick={() => this.onEditInvoice(row, refetch)}>
          Edit
        </Button>
        <Divider type={'vertical'} />

        <Button onClick={() => this.goToInvoice(row.id)}>
          Download
        </Button>
        <Divider type={'vertical'} />
        <Button onClick={() => this.onSendInvoice(row, sendInvoice, refetch)}>
          Send
        </Button>
        <Divider type={'vertical'} />

        <Button danger={true} onClick={() => this.onDeleteInvoice(row, deleteInvoice, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private hideEditModal() {
    this.setState({
      editInvoice: null,
    });
  }

  private onEditInvoice(invoice: GQL.IInvoice, refetch: Function) {
    this.setState({
      editInvoice: invoice,
    });
  }

  private goToInvoice(id: string) {
    window.location.href = `${url}/invoices/generate?invoiceId=${id}`;
  }

  private onSendInvoice(invoice: GQL.IInvoice, sendInvoice: Function, refetch: Function) {
    Modal.confirm({
      title: `Send invoice`,
      content: (
        <span>
          Are you sure you want to send invoice <strong>{invoice.invoiceNumber}</strong> to customer ?
        </span>
      ),
      onOk: () => {
        return sendInvoice({
          variables: {
            id: invoice.id
          }
        }).then(() => refetch());
      }
    });
  }

  private onDeleteInvoice(invoice: GQL.IInvoice, deleteInvoice: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete invoice`,
      content: (
        <span>
          Are you sure you want to delete invoice <strong>{invoice.invoiceNumber}</strong> ?
        </span>
      ),
      onOk: () => {
        return deleteInvoice({
          variables: {
            id: invoice.id
          }
        }).then(() => refetch());
      }
    });
  }

  private async generateInvoice(invoiceType: string, sendToCustomer: boolean) {
    if (this.props.createInvoice) {
      await this.props.createInvoice({
        variables: {
          orderId: this.props.orderId,
          invoiceType,
          sendToCustomer: !!sendToCustomer,
        }
      })
      .then((response) => response.data)
      .then((result) => {
        if (result && result.createInvoice && result.createInvoice.missingAuthorization && result.createInvoice.popUpUrl) {
          window.open(result.createInvoice.popUpUrl, '_blank');
        } else {
          // done
          notification['success']({
            message: 'Info',
            description: `${invoiceType === 'invoice' ? `Invoice` : `Proforma`} has been created.`
          });
          // odesláno
          if (
            result
              && result.createInvoice
              && result.createInvoice.sendToCustomer === true
          ) {
            notification['success']({
              message: 'Info',
              description: `${invoiceType === 'invoice' ? `Invoice` : `Proforma`} has been send to customer.`
            });
          }
        }
      })
      .catch((error) => {
        notification['error']({
          message: 'Error',
          description: error.toString()
        });
      });
    }
  }

  private async publishToFreshbooks(func: Function, invoiceId: string, refetch: Function) {
    // dotaz na odeslání faktury do freshbooks
    const publishUrl = `${url}/invoices/publish-to-freshbooks?invoiceId=${invoiceId}`;
    axios.get(publishUrl)
      .then(res => {
        if (res.data.success === true) {
          refetch();
          // done
          notification['success']({
            message: 'Info',
            description: `Invoice has been published.`
          });
        } else {
          // ostatní
          notification['error']({
            message: 'Error',
            description: `Publishing invoice failed!${res.data.message ? ` (${res.data.message})` : ``}`,
          });
        }
      })
      .catch(err => {
        if (err.response && err.response.data) {
          const { data } = err.response;
          // neautorizován
          if (data.success === false && data.statusText === 'unauthorized') {
            Modal.confirm({
              title: 'Freshbooks not authorized',
              content: 'Do you want authorize to Freshbooks?',
              onOk() {
                window.open(data.authorizeUrl, '_blank');
              },
              onCancel() {
              },
            });
          } else {
            // ostatní
            notification['error']({
              message: 'Error',
              description: `Publishing invoice failed!`,
            })
          }
        }
      })

  }

  private async publishToQuickbooks(invoiceId: string, refetch: Function, refetchOrder?: Function) {
    // dotaz na odeslání faktury do freshbooks
    const publishUrl = `${url}/invoices/publish-to-quickbooks?invoiceId=${invoiceId}`;
    this.setState({ publishingToQuickbooks: true });
    axios.get(publishUrl, {
      headers: {
        Authorization: localStorage.getItem('token') ? `${localStorage.getItem('token')}` : null
      }
    })
      .then(res => {
        this.setState({ publishingToQuickbooks: false });
        if (res.data.success === true) {
          refetch();
          // done
          notification['success']({
            message: 'Quickbooks info',
            description: `Invoice has been published.`
          });
        } else if (res.data.missingAuthorization && 'string' === typeof res.data.popUpUrl) {
          window.open(res.data.popUpUrl, '_blank');
        } else {
          // ostatní
          notification['error']({
            message: 'Quickbooks Error',
            description: `Publishing invoice failed!${res.data.message ? ` (${res.data.message})` : ``}`,
          });
          if (refetchOrder) {
            refetchOrder();
          }
        }
      })
      .catch(err => {
        this.setState({ publishingToQuickbooks: false });
        if (err.response && err.response.data) {
          const { data } = err.response;
          notification['error']({
            message: 'Quickbooks Error',
            description: `Publishing invoice failed!${data.message ? ` (${data.message})` : ''}`,
          });
        } else {
          notification['error']({
            message: 'Quickbooks Error',
            description: `Publishing invoice failed! ${err}`,
          })
        }
        if (refetchOrder) {
          refetchOrder();
        }
      })

  }
}

export default withRouter(OrderInvoices);



// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/OrderInvoices/OrderInvoices.tsx